import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import Nav from "../../components/Nav";
// import StripeCheckoutButton from "../../components/StripeCheckoutButton";
// import AnchorLink from "react-anchor-link-smooth-scroll";
import fetch from "isomorphic-fetch";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total: null,
      target: 1000,
    };
  }

  componentDidMount() {
    const url = `https://2tjkrkn7p7.execute-api.eu-west-1.amazonaws.com/dev/total`;

    fetch(url, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        this.setState({ total: parseInt(response.count) });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let spotlights = [
      {
        title: "£75 Cash Prize",
        intro: "£75 cash to spend as you wish, provided by Upton Priory PTFA.",
        img: "/static/media/75prize.jpeg",
        winner: {
          email: "natalie_hewitt@hotmail.co.uk",
          session:
            "cs_live_a1veZNRi48kxTilcyOEeQqHyR92HBRQpontSOftUZBP1yYAEeVW1bx51l9",
          name: "Natalie Hewitt",
          phone: "07827323591",
          ticketId: "84437",
        },
      },
      {
        title: "£50 Cash Prize",
        intro: "£50 cash to spend as you wish, provided by parent donation.",
        img: "/static/media/50prize.jpeg",
        winner: {
          email: "julietteh1@hotmail.co.uk",
          session:
            "cs_live_a1GaJLZn19cKvUHI5O48EClqFytUIxKCdWMEVgMWGenByTIQzOZayDra6S",
          name: "Juliette Hewitt",
          phone: "07885117280",
          ticketId: "72173",
        },
      },
      {
        title: "£50 Cash Prize",
        intro: "£50 cash to spend as you wish, provided by parent donation.",
        img: "/static/media/50prize.jpeg",
        winner: {
          email: "david_adam@live.co.uk",
          session:
            "cs_live_a1C6WVsUKQt0qRevH6WJUCYgKjQIwTLKiTvaxADj9MIZEpUrGpbl8IjmLK",
          name: "David Adam",
          phone: "07549665857",
          ticketId: "87739",
        },
      },
      {
        title: "Twilight Spa Experience",
        intro:
          'Twilight spa access for 2 with a glass of fizz at <a target="_blank" href="https://www.shrigleyhallhotelandspa.co.uk/">Shrigley Hall</a>.',
        img: "/static/media/shrigley.jpg",
        winner: {
          email: "natalie_hewitt@hotmail.co.uk",
          session:
            "cs_live_a1veZNRi48kxTilcyOEeQqHyR92HBRQpontSOftUZBP1yYAEeVW1bx51l9",
          name: "Natalie Hewitt",
          phone: "07827323591",
          ticketId: "79756",
        },
      },
      {
        title: "Bowling Party for 4!",
        intro:
          '2 games of bowling for a maximum of 4 people, and 1 round of drinks <a target="_blank" href="https://wynwoodlanes.co.uk//">Wynwood Lanes, Manchester</a>.',
        img: "/static/media/wynwood.jpeg",
        winner: {
          email: "kellymillington@sky.com",
          session:
            "cs_live_a1tXHLY7CkHAXjPFOozvdrela3qfAfB5l6TwsoT3yGMDbC22c1Ebn2zsRG",
          name: "Kelly Millington",
          phone: "07702012254",
          ticketId: "71422",
        },
      },
      {
        title: "Gails Bakery Treats",
        intro:
          'A selection of treats from <a target="_blank" href="https://gailsbread.co.uk/">Gails Bakery</a>.',
        img: "/static/media/gails.jpeg",
        winner: {
          email: "dollysteff@hotmail.com",
          session:
            "cs_live_a11BJWrKLyqJHsmTsJkqm39Bn4KDVSINmBlrgo7TC3sqtKM7dYSXkxQLpa",
          name: "Stephanie Risk",
          phone: "07930620207",
          ticketId: "97499",
        },
      },
      {
        title: "Axe Throwing",
        intro:
          'An hour long axe throwing session for two people (age 13+ only) at <a target="_blank" href="https://thevikingaxe.co.uk/">The Viking Axe, Macclesfield</a>.',
        img: "/static/media/axe.jpg",
        winner: {
          email: "ps.iris@gmail.com",
          session:
            "cs_live_a1qccMTMXdkEF697R7WFms7tHTFGLrGmBbdEmZPgMRuKHoBKJtnQUvegkY",
          name: "Iris Chan",
          phone: "0753618744",
          ticketId: "53425",
        },
      },
      {
        title: "Yoga Session",
        intro:
          'Deep Rest Yoga Session provide by <a target="_blank" href="https://www.wiseheartsam.com/">Wise Heart Sam</a>.',
        img: "/static/media/yoga.jpeg",
        winner: {
          email: "kezlewisjames@gmail.com",
          session:
            "cs_live_a1icGCrl8Mc07rHnIRjMH9t20QDstnIetlXzZ0JUKJk8znNBAjhXjfhSUa",
          name: "Kerrie Thorley ",
          phone: "07927854070",
          ticketId: "77105",
        },
      },
      {
        title: "£25 One4All Voucher",
        intro:
          '£25 One4All voucher donated by Zenka. Usable at over 40 high street retailers including Argos, Boots, Debenhams, M&S and many more. <a target="_blank" href="https://www.one4all.com/uk/">More Info</a>.',
        img: "/static/media/one4all-logo.jpg",
        winner: {
          email: "eleanor_seager@hotmail.co.uk",
          session:
            "cs_live_a1l74iNLL49y21naj7SOI7AA4j8Y5EJ4qzwuSs83DO7a48DsMchnvsp7Zm",
          name: "Ellie Browne",
          phone: "07445264516",
          ticketId: "78539",
        },
      },
      {
        title: "VT Personal Training",
        intro:
          'Enjoy 3 free classes at <a target="_blank" href="https://www.vtpersonaltraining1.com/">VT Personal Training</a>.',
        img: "/static/media/training.jpg",
        winner: {
          email: "Mikebyrne518@gmail.com",
          session:
            "cs_live_a1C6emV90MkKXLXlj2238XIEYZhLONfNVSqNcZ6dqYdP8ljE32OISSJCa1",
          name: "Mike Byrne ",
          phone: "07795 314958 ",
          ticketId: "62149",
        },
      },
      {
        title: "Toys and Puzzles",
        intro:
          'Selection of toys and puzzles kindly donated by <a target="_blank" href="https://www.thetoyshop.com/">The Entertainer</a>.',
        img: "/static/media/games.jpeg",
        winner: {
          email: "vickie_watkinson@hotmail.com",
          session:
            "cs_live_a1P98AUoF0Cna7BuPWIniMim3nXygErrmkYrRpHq9w59ROmHCH9ljy7ZSd",
          name: "vickie holmes",
          phone: "07426935953",
          ticketId: "52735",
        },
      },
      {
        title: "Gifts from Tesco",
        intro:
          'A selection of gifts including a Disney book and a Nivea Men gift set from <a target="_blank" href="https://www.tesco.com/">Tesco</a>.',
        img: "/static/media/tesco.jpeg",
        winner: {
          email: "nataliestratton80@gmail.com",
          session:
            "cs_live_a1Lt5TYDYzd5tkvkcwb4sf9smM8WFFqyEcRBcM5UQhuq7YH7TRSmh3NmZO",
          name: "Karen Lahan",
          phone: "07734865881",
          ticketId: "29700",
        },
      },
      {
        title: "Gifts from Tesco",
        intro:
          'A selection of gifts including a Disney book and a Nivea Men gift set from <a target="_blank" href="https://www.tesco.com/">Tesco</a>.',
        img: "/static/media/tesco.jpeg",
        winner: {
          email: "hannah.lorquet@gmail.com",
          session:
            "cs_live_a1oysbWwpH6zXaE9iistDyYD1yFeC1HGhOFN1dJotpYZhwj17Bg5E0TMAc",
          name: "Hannah Lorquet",
          phone: "07849 559717",
          ticketId: "38526",
        },
      },
      {
        title: "Golf Voucher for 4",
        intro:
          'Round of golf for 4 at <a target="_blank" href="https://www.thetytheringtonclub.com/golf/">Tytherington Golf Club</a>.',
        img:
          "https://www.thetytheringtonclub.com/assets/images/sections/10618-card-1.jpg",
        winner: {
          email: "heidifleming@outlook.com",
          session:
            "cs_live_a1Zw6PKVG4nJDyuE58KshyR0j7j69jlpxA2akL8opoOW7KP0n2AH2F7J1j",
          name: "Heidi Fleming",
          phone: "07713487528",
          ticketId: "96403",
        },
      },
      {
        title: "Pottery Painting",
        intro:
          'Pottery painting session for 1 at <a target="_blank" href="https://www.periwinkleandclaystudio.com/">Periwinkle and Clay Studio</a>.',
        img: "/static/media/periwinkle.jpg",
        winner: {
          email: "rosie.grant00@gmail.com",
          session:
            "cs_live_a10F47rj1Zym2ZsHqdq7ITo4sBYKLMwoF9gbiVVixTOafiR7ETI88Ug6rH",
          name: "Rosie Grant",
          phone: "07816921593",
          ticketId: "32903",
        },
      },
      {
        title: "Childrens Bouldering Session",
        intro:
          '1x childrens bouldering session at <a target="_blank" href="https://www.substation.co.uk/">Substation</a>.',
        img: "/static/media/substation.jpg",
        winner: {
          email: "nataliestratton80@gmail.com",
          session:
            "cs_live_a1NP4UkMKFAfeP43856a34MRwimfOIf8VxGD7BFAZMYwahBRax4J39zVzO",
          name: "Natalie Stratton",
          phone: "07734865881",
          ticketId: "22562",
        },
      },
      {
        title: "£10 Ethical Schoolwear Voucher",
        intro:
          '£10 ethical schoolwear voucher to spend at <a target="_blank" href="https://ethicalschoolwear.com/">Ethical Schoolwear</a>.',
        img:
          "https://ethicalschoolwear.com/cdn/shop/files/Screenshot_2022-09-30_at_16.24.01.png?v=1664551456&width=500",
        winner: {
          email: "nataliestratton80@gmail.com",
          session:
            "cs_live_a1NP4UkMKFAfeP43856a34MRwimfOIf8VxGD7BFAZMYwahBRax4J39zVzO",
          name: "Natalie Stratton",
          phone: "07734865881",
          ticketId: "79485",
        },
      },
      {
        title: "Tropic Set",
        intro:
          'Tropic body wash and facecloth from  <a target="_blank" href="https://tropicskincare.com/pages/sandracook">Sandra Tropic Embasador</a>.',
        img: "/static/media/tropic.jpg",
        winner: {
          email: "julietteh1@hotmail.co.uk",
          session:
            "cs_live_a1GaJLZn19cKvUHI5O48EClqFytUIxKCdWMEVgMWGenByTIQzOZayDra6S",
          name: "Juliette Hewitt",
          phone: "07885117280",
          ticketId: "35739",
        },
      },
      {
        title: "Chocolates",
        intro:
          'Chocolates from  <a target="_blank" href="https://www.facebook.com/Hannahrosecakes/">Hannah Rose Cakes</a>.',
        img: "/static/media/chocolates.jpeg",
        winner: {
          email: "eleanor_seager@hotmail.co.uk",
          session:
            "cs_live_a1l74iNLL49y21naj7SOI7AA4j8Y5EJ4qzwuSs83DO7a48DsMchnvsp7Zm",
          name: "Ellie Browne",
          phone: "07445264516",
          ticketId: "11238",
        },
      },
      {
        title: "Battle Robots",
        intro: "Road Kombat Tornado Battle Robots from parent donation.",
        img: "/static/media/battlerobot.jpg",
        winner: {
          email: "Karensimm@hotmail.com",
          session:
            "cs_live_a1iAzX0JoBBIyDYjEqS7TMlv7s52QNaXFwugbcr83X1fI6mkldLDeEym9w",
          name: "Karen Williams ",
          phone: "07778 612749 ",
          ticketId: "93508",
        },
      },
      {
        title: "Board Games",
        intro: "Azul and The Chameleon Board Games from parent donation.",
        img: "/static/media/boardgames.jpg",
        winner: {
          email: "kellymillington@sky.com",
          session:
            "cs_live_a1tXHLY7CkHAXjPFOozvdrela3qfAfB5l6TwsoT3yGMDbC22c1Ebn2zsRG",
          name: "Kelly Millington",
          phone: "07702012254",
          ticketId: "80059",
        },
      },
    ];

    return (
      <div>
        <Helmet>
          <title>Upton Priory School - PTFA Christmas Competition</title>
          <meta
            name="description"
            content="PTFA Christmas Competition. £1 per entry. Answer a simple question to win £75 and much more!"
          />

          <meta property="og:url" content="https://uptonprioryraffle.com" />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="Upton Priory School - PTFA Christmas Competition"
          />
          <meta
            property="og:description"
            content="PTFA Christmas Competition. £1 per entry. Answer a simple question to win £75 and much more!"
          />
          <meta
            property="og:image"
            content="https://uptonprioryraffle.com/static/media/upton.png"
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:domain" content="uptonprioryraffle.com" />
          <meta
            property="twitter:url"
            content="https://uptonprioryraffle.com"
          />
          <meta
            name="twitter:title"
            content="Upton Priory School - PTFA Christmas Competition"
          />
          <meta
            name="twitter:description"
            content="PTFA Christmas Competition. £1 per entry. Answer a simple question to win £75 and much more!"
          />
          <meta
            name="twitter:image"
            content="https://uptonprioryraffle.com/static/media/upton.png"
          />
        </Helmet>
        <div className="container mx-auto pt-8 pb-8">
          <Nav />
        </div>

        <div className="bg-upton-100 pt-8 pb-8">
          <div className="flex-1 flex flex-col items-center justify-center container mx-auto pl-6 pr-6 lg:pl-0 lg:pr-0">
            <h1 className="text-white text-center text-4xl lg:text-6xl uppercase font-black">
              Christmas <span className="font-normal">Competition</span>
            </h1>
            <p className="w-full text-white text-center text-xl lg:text-2xl font-thin mt-6">
              The competition has now closed. Thank you for entering!
            </p>
            <p className="w-full text-white text-center text-xl lg:text-2xl font-thin mt-6">
              Winners will be emailed over the next week, but you can check your
              numbers below.
            </p>
            {/* <p className="w-full text-white text-left text-xl lg:text-2xl font-thin mt-6 ">
              From cash prizes and shopping vouchers to exciting experiences
              like bowling, axe throwing, and yoga, plus festive treats and gift
              sets - you’re sure to find something you love! Browse the prize
              gallery below and click the links for more details on these
              fantastic rewards.
              <p className="w-full text-white text-left text-xl lg:text-2xl font-thin mt-6 ">
                Tickets are just £1 each, and you can buy as many as you like
                online. Spread the word - everyone can enter!
              </p>
              <p className="w-full text-white text-left text-xl lg:text-2xl font-thin mt-6 ">
                The prize draw will take place on Friday 12th December, and
                winners will be notified by email.
              </p>
            </p>
            <p className="w-full text-white text-left text-xl lg:text-2xl font-thin mt-6 ">
              Good luck!
            </p>

            <AnchorLink
              className="disabled text-white text-xl lg:text-2xl font-bold uppercase bg-orange-700 hover:bg-orange-500 p-4 inline-block mt-8 mb-8"
              href="#buy-tickets"
            >
              Enter Competition
            </AnchorLink> */}
            {/* <>
              {!!this.state.total && (
                <div className="w-full mt-4">
                  <p className="text-center w-full text-white text-xl lg:text-2xl font-thin mt-6 mb-0">
                    So far we have raised £{this.state.total} of our £
                    {this.state.target} target.
                  </p>
                  <div className="meter red">
                    <span
                      style={{
                        width:
                          Math.round(
                            (this.state.total / this.state.target) * 100
                          ) + "%",
                      }}
                    />
                  </div>
                </div>
              )}
            </> */}
          </div>
        </div>

        <div className="w-100 flex flex-col justify-center bg-gradient-to-b to-black from-gray-1400 relative pt-12 pb-12">
          <div className="container flex flex-row flex-wrap mx-auto z-10">
            {spotlights
              .sort(() => Math.random() - 0.5)
              .map((s, i) => (
                <div className={`w-full lg:w-1/3 text-white p-4  text-center`}>
                  <img
                    className="w-full h-48 rounded-lg rounded-b-none object-cover mx-auto"
                    src={s.img}
                  />

                  <div className="bg-gray-1300 rounded-lg  rounded-t-none p-6 pb-6 pt-6 text-center">
                    <h2 className="text-white text-2xl font-black uppercase">
                      <span className="font-normal">{s.title}</span>
                    </h2>
                    <div className="text-white mt-5 font-light text-sm h-20 intro">
                      <span dangerouslySetInnerHTML={{ __html: s.intro }} />
                    </div>
                    {s.winner && (
                      <p className="text-white mt-5 font-light text-sm h-12 intro">
                        Winning number: {s.winner.ticketId}
                      </p>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* <div
          id="buy-tickets"
          className="container mx-auto pt-12 pb-12 pl-4 pr-4"
        >
          <StripeCheckoutButton />
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = ({ data }) => ({
  data,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
